/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PesquisaUtilizacaoAliases {
  AUTOCOMPLETE_0 = 'autocomplete-0',
  AUTOCOMPLETE_ORIGEM = 'autocomplete-origem',
  CARD_0 = 'card-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DATE_FIELD_0 = 'date-field-0',
  DATE_FIELD_1 = 'date-field-1',
  DATE_FIELD_2 = 'date-field-2',
  DECK_0 = 'deck-0',
  FETCH_1 = 'fetch-1',
  FETCH_3 = 'fetch-3',
  FETCH_DADOS_BENEFICIARIO = 'fetch-dados-beneficiario',
  FETCH_ORIGEM = 'fetch-origem',
  FETCH_PROCEDIMENTOS = 'fetch-procedimentos',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_4 = 'field-4',
  FIELD_5 = 'field-5',
  FIELD_6 = 'field-6',
  FIELD_8 = 'field-8',
  FIELD_9 = 'field-9',
  FIELD_10 = 'field-10',
  FIELD_11 = 'field-11',
  FIELD_12 = 'field-12',
  FIELD_13 = 'field-13',
  FIELD_LOCATOR = 'field-locator',
  FIELD_ORIGEM = 'field-origem',
  FILTER_CONSULTA = 'filter-consulta',
  FILTERED_LIST_0 = 'filtered-list-0',
  FORM_0 = 'form-0',
  HPMS_CUSTOM_CARD_0 = 'hpms-custom-card-0',
  INPUT_0 = 'input-0',
  INPUT_1 = 'input-1',
  INPUT_2 = 'input-2',
  INPUT_CODIGO = 'input-codigo',
  LOCATOR_0 = 'locator-0',
  LOCATOR_FIELD_CODIGO = 'locator-field-codigo',
  MAPPER_0 = 'mapper-0',
  MAPPER_10 = 'mapper-10',
  MAPPER_ORIGEM = 'mapper-origem',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_PESQUISA_UTILIZACAO = 'panel-pesquisa-utilizacao',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TEXT_5 = 'text-5',
  TEXT_6 = 'text-6',
  TEXT_ORIGEM = 'text-origem',
}
export { PesquisaUtilizacaoAliases };
